import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { createKnowledgeIngest, getGoogleDriveIngestInfo } from '../../../api/knowledgeBases';
import { getApiErrorMessage } from '../../../utils/errors';
import KnowledgeIngestForm from '../../KnowledgeBases/components/KnowledgeIngestForm';
import { DEFAULT_INGEST_SOURCE } from '../../KnowledgeBases/constants';
import WizardShell from '../components/WizardShell';

function KnowledgeSetup({ totalSteps, initialValues, onBack, onSuccess }) {
  const location = useLocation();
  const [googleDriveInfo, setGoogleDriveInfo] = useState(null);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getGoogleDriveIngestInfo()
      .then(setGoogleDriveInfo)
      .catch(() => setGoogleDriveInfo(null));
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('google_drive') === 'connected') {
      setNotice('Google Drive conectado com sucesso.');
      setError('');
    } else if (params.get('google_drive') === 'error') {
      setError(params.get('message') || 'Falha ao conectar Google Drive.');
    }
  }, [location.search]);

  const handleSubmit = async (payload) => {
    setError('');
    setIsSubmitting(true);

    try {
      const kb = await createKnowledgeIngest(payload);
      onSuccess({
        knowledgeBaseId: kb.id,
        name: kb.name,
        sourceType: kb.source_type,
        sourceRef: kb.source_ref,
        status: kb.status,
        opensearchIndex: kb.opensearch_index,
      });
    } catch (err) {
      setError(getApiErrorMessage(err, 'Não foi possível cadastrar a base de conhecimento.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <WizardShell
      title="Cadastrar conhecimento"
      subtitle="Importe uma pasta do Google Drive ou escolha outra origem."
      step={2}
      totalSteps={totalSteps}
    >
      {notice && (
        <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2 mb-4">
          {notice}
        </p>
      )}

      <KnowledgeIngestForm
        initialValues={{ ...initialValues, source: initialValues.source || DEFAULT_INGEST_SOURCE }}
        googleDriveInfo={googleDriveInfo}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        submitLabel="Salvar e continuar"
        error={error}
      />

      <button
        type="button"
        onClick={onBack}
        disabled={isSubmitting}
        className="btn-secondary w-full mt-4 disabled:opacity-50"
      >
        Voltar
      </button>
    </WizardShell>
  );
}

export default KnowledgeSetup;
